export default __webpack_public_path__ + "static/media/litchifiction.f40f4a6b.png";